export var ApplicationEnum;
(function (ApplicationEnum) {
    ApplicationEnum[ApplicationEnum["Platform"] = 0] = "Platform";
    ApplicationEnum[ApplicationEnum["Wallet"] = 1] = "Wallet";
    ApplicationEnum[ApplicationEnum["Seamless"] = 2] = "Seamless";
})(ApplicationEnum || (ApplicationEnum = {}));
//# sourceMappingURL=ApplicationEnum.js.map